
export default {
  path: '/app-users',
  name: 'app-users',
  meta: {
    title: '用户中心'
  },
  component: () => import('@/conf/home/pages/users'),
  children: [
    {
      path: '/app-users/password',
      name: 'app-users-password',
      meta: {
        title: '修改密码',
        auth: true
      },
      component: () => import('@/conf/home/pages/users/password/password')
    },
    {
      path: '/app-users/personal',
      name: 'app-users-personal',
      meta: {
        title: '修改用户信息',
        auth: true
      },
      component: () => import('@/conf/home/pages/users/personal/personal')
    }
  ]
}



// WEBPACK FOOTER //
// ./src/js/conf/home/router/users.js